import React from 'react'
import { NavHashLink } from "react-router-hash-link";
import { HeaderMenuLinks } from '../constants/data';
import { scrollWithOffset } from '../utils/helpers';

const MenuLinks = ({isVisible=""}) => {
    return (
        <div className="flex lg:gap-10 gap-2 flex-wrap">
        {HeaderMenuLinks.map((item) => {
            return (
                <NavHashLink
                    key={item.name}
                    className={`${isVisible} hover:text-main transitions uppercase`}
                    scroll={(el) => scrollWithOffset(el, 120)}
                    to={item.path === 'services' ?  'services_page' : `/#${item.path}` }
                >
                    {item.name}
                </NavHashLink>
            );
        })}
    </div>
    )
}

export default MenuLinks
